export const CHANNEL_CONTAINER_ID = 'str-chat__channel';
